module.exports = __webpack_public_path__ + "assets/img/jairo_mora_sandoval-7fc4b51f.jpg";